import { render, staticRenderFns } from "./StatisticsPathoInvoiceManager.vue?vue&type=template&id=67b3780c"
import script from "./StatisticsPathoInvoiceManager.vue?vue&type=script&lang=js"
export * from "./StatisticsPathoInvoiceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports